import { render, staticRenderFns } from "./EntityService.vue?vue&type=template&id=778c42a4&scoped=true"
import script from "./EntityService.vue?vue&type=script&lang=js"
export * from "./EntityService.vue?vue&type=script&lang=js"
import style0 from "./EntityService.vue?vue&type=style&index=0&id=778c42a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "778c42a4",
  null
  
)

export default component.exports